/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.3.0
 * @since 1.0.0
 */
import React, { memo } from 'react';

import { EllipseText, LinkBlock } from '../index';
import { ILinkProps } from './LinkBlock';

interface ILinkEllipseProps extends ILinkProps {
    children: any;
    isBlack?: boolean;
    isExternalUrl?: boolean;
    onClick?: () => void;
    onWheelClick?: (e: React.MouseEvent) => void;
    title: string;
    url?: string;
}

const LinkEllipseBlock = (props: ILinkEllipseProps) => (
    <EllipseText title={props.title}>
        <LinkBlock {...props}>
            {props.children}
        </LinkBlock>
    </EllipseText>
);
LinkEllipseBlock.defaultProps = {
    children: '',
    title: '',
    url: '',
};

export default memo(LinkEllipseBlock);
